module.exports = __webpack_public_path__ + "img/fondo_ team_backing_Mesa_de_trabajo_1.e713795e.png";